import React from 'react'

const Alert = props => (
  <svg width={16} height={16} {...props}>
    <defs>
      <path
        id="alert_svg__a"
        d="M8 2a.55.55 0 01.239.058.542.542 0 01.14.093c.005.004.012.007.017.012a.51.51 0 01.09.12l6.112 10.909a.537.537 0 01-.008.54.56.56 0 01-.479.268H1.89a.555.555 0 01-.478-.268.535.535 0 01-.009-.54l6.111-10.91a.543.543 0 01.093-.12l.012-.01a.545.545 0 01.143-.094l.047-.02A.56.56 0 018 2zm0 8.72a.652.652 0 00-.662.64c0 .353.297.64.662.64a.652.652 0 00.662-.64.652.652 0 00-.662-.64zM8.35 6h-.7a.312.312 0 00-.317.305v2.958c0 .356.3.645.667.645.368 0 .667-.29.667-.645V6.305A.311.311 0 008.351 6z"
      />
    </defs>
    <use fill={props.fill} xlinkHref="#alert_svg__a" fillRule="evenodd" />
  </svg>
)

export default Alert

